import AppContent from "../templates/wrapper/AppContent";
import AccountInfoSection from "../organisms/sections/accountInfo/AccountInfoSection";
import MobileBanner from "../molecules/layouts/app/MobileBanner";
import { useTranslation } from "react-i18next";

export default function AccountInfo() {
  const { t } = useTranslation();

  return (
    <>
      <MobileBanner isShowTitle />
      <AppContent title={t("home.accountInfo")}>
        <AccountInfoSection />
      </AppContent>
    </>
  );
}
